import { RolesState } from "./states/roles.state";

export const roleStates = [
    RolesState,
];
